<template>
	<div class="reportToDownload">
		<!-- 筛选 -->
		<filter-panel
			style="width: 100%"
			:data="group"
			:hideResult="true"
			@search="filterChange"
		></filter-panel>
		<!-- 列表 -->
		<data-list
			:table-style="{ name: 'mixture' }"
			:data="data"
			:btnList="btnList"
			:columns="columns"
			:page="page"
			:loading="loading"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
		></data-list>

		<!-- 创建手动报告表单弹窗 -->
		<manualReportForm ref="manualReportForm" dialogWidth="900px" title="创建手动报告" />
	</div>
</template>

<script>
import listPageCreate from '@/mixins/listPageCreate';
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import manualReportForm from './form/manualReportForm';
import { download } from '@/common/util.js';
import googleads from '@/backend/services/googleAds/googleAds.js';
import api from '@/backend/apiConfig/apiConfig';
import { transferDate } from '@/utils/index.js';
import customer from '@/mixins/customer';

import dayjs from 'dayjs';

const page = listPageCreate({
	searchConfig: {
		api: api.googleAds.getReportList,
		method: 'POST',
		config: {
			timeout: 60000,
		},
	},
	getQuery(obj, that) {
		let { searchType, searchValue, time } = obj;
		let timeType = that.group.others[4].type;
		let startDate = '';
		let endDate = '';
		if (time) {
			// console.log(time);
			switch (timeType) {
				case 'week':
					let valChange = new Date(time) - 1 * 24 * 3600 * 1000;
					let weekEnd = valChange + 6 * 24 * 3600 * 1000;
					weekEnd = transferDate(new Date(weekEnd));
					let timeCopy = transferDate(new Date(valChange));
					startDate = timeCopy;
					endDate = weekEnd;
					break;
				case 'month':
					let M = new Date(time).getMonth() + 1;
					let Y = new Date(time).getFullYear();
					let lange = new Date(Y, M, 0).getDate();
					let arr = time.split('-');
					arr[2] = lange - 0;
					startDate = time;
					endDate = arr.join('-');
					break;
				case 'daterange':
					startDate = time[0];
					endDate = time[1];
					break;
			}
		}
		switch (searchType) {
			case 0:
				obj.serviceCode = searchValue;
				break;
			case 1:
				obj.cid = searchValue;
				break;
			case 2:
				obj.serviceStaffName = searchValue;
				break;
		}
		delete obj.searchType;
		delete obj.searchValue;
		delete obj.time;
		return _.assign(obj, {
			startDate,
			endDate,
		});
	},
});

function getTime() {
	let time = new Date(dayjs().day(-5).$d);
	return transferDate(time);
}

function getMonthTime() {
	var nowdays = new Date();
	var year = nowdays.getFullYear();
	var month = nowdays.getMonth();
	if (month == 0) {
		month = 12;
		year = year - 1;
	}
	if (month < 10) {
		month = '0' + month;
	}

	return year + '-' + month + '-01'; //上个月第一天
}

export default {
	name: 'reportToDownload',
	props: [],
	components: {
		filterPanel,
		manualReportForm,
	},
	mixins: [page, customer],
	data() {
		let self = this;
		return {
			manualReportFormData: {},
			btnList: [
				{
					name: '余额匹配',
					position: 'right',
					showBtn: () => {
						return self.getPermission('balanceMatching');
					},
					attribute: {
						type: 'primary',
						loading: false,
					},
					btnClick() {
						self.$router.push({
							name: 'balanceMatching',
						});
					},
				},
				{
					name: '创建手动报告',
					position: 'right',
					showBtn: () => {
						return true;
					},
					attribute: {
						loading: false,
					},
					async btnClick() {
						let { manualReportFormData } = self;
						let { cancel, ...data } = await self.$refs.manualReportForm.show({
							manualReportFormData,
						});
						self.manualReportFormData = data;
						if (!cancel) {
							self.query();
						}
					},
				},
				{
					name: '模板管理',
					position: 'right',
					showBtn: () => {
						return true;
					},
					attribute: {
						type: 'primary',
						loading: false,
					},
					btnClick() {
						self.$router.push({
							name: 'templateManagement',
						});
					},
				},
			],
			columns: [
				{
					label: '报告类型',
					bind: val => {
						let { type } = val;
						switch (type - 0) {
							case 1:
								return '自动周报';
							case 2:
								return '自动月报';
							case 3:
								return '自定义报告';
						}
						return '-';
					},
				},
				{
					label: '日期范围',
					type: 'custInfo',
					width: '200px',
					text: [
						{
							custValue(val) {
								let { startDate, endDate } = val;
								return `${startDate.split(' ')[0]} ~ ${endDate.split(' ')[0]}`;
							},
						},
					],
				},
				{
					label: '客户名称/服务单',
					type: 'custInfo',
					text: [
						{
							label: '',
							bind: 'customerName',
						},
						{
							label: '',
							bind: 'serviceCode',
						},
					],
				},
				{
					label: '优化师/CID',
					type: 'custInfo',
					text: [
						{
							label: '',
							bind: 'serviceStaffName',
						},
						{
							label: '',
							bind: 'cid',
						},
					],
				},
				{
					label: '消耗',
					bind: 'cost',
				},
				{
					label: '优化师建议',
					bind: 'remark',
					type: 'preview',
					iconName: 'bianji',
					dataStyle: {
						'justify-content': 'flex-start',
					},
					dataFormat: val => {
						if (val === null) return '未添加';
						else return '已添加';
					},
					iconDisabled: val => {
						let { status } = val;
						if (status == 1) return false;
						return true;
					},
					preview(row) {
						let { id } = row;
						self.toReportDetails(id);
					},
				},
				{
					label: '报告生成状态',
					bind: val => {
						let { status } = val;
						switch (status - 0) {
							case 0:
								return '生成中';
							case 1:
								return '已生成';
							case 2:
								return '生成失败';
						}
						return '-';
					},
				},
				{
					label: '下载状态',
					content: '仅当归属优化师已下载时，状态为"已下载"',
					bind: val => {
						let { mark } = val;
						if (mark) return '已下载';
						return '未下载';
					},
				},
				{
					label: '是否发送报告',
					bind: val => {
						let { sendStatus } = val;
						switch (sendStatus) {
							case true:
								return '是';
							case false:
								return '否';
							default:
								return '-';
						}
					},
				},
				{
					label: '操作',
					type: 'btnClick',
					style: 'text',
					width: 230,
					bind: () => {
						return [
							{
								text: '详情',
								showButton(val) {
									let { status } = val;
									return status === 1;
								},
								trigger: row => {
									let { id } = row;
									self.toReportDetails(id);
								},
							},
							{
								text: '下载',
								showButton(val) {
									let { status } = val;
									return status === 1;
								},
								trigger: async row => {
									let {
										excelPath: url,
										remark,
										id,
										type,
										customerName,
										domain,
										startDate,
										endDate,
									} = row;
									let time = `${startDate.split(' ')[0]} ~ ${endDate.split(' ')[0]}`;
									let typeNmae = '';
									switch (parseInt(type)) {
										case 1:
											typeNmae = '自动周报';
											break;
										case 2:
											typeNmae = '自动月报';
											break;
										case 3:
											typeNmae = '自定义报告';
											break;
									}
									let fileName = `${typeNmae}_${customerName}_${domain}_${time}.xlsx`;
									if (remark === null) {
										let control = await self.$confirmShow(
											'未添加优化师建议，是否继续下载？',
											'提示',
											{
												confirmButtonText: '添加建议',
												cancelButtonText: '继续下载',
												distinguishCancelAndClose: true,
											}
										);
										if (control === 'cancel') self.reportDownload({ url, fileName, id });
										if (control === 'confirm') self.toReportDetails(id);
										return;
									}
									self.reportDownload({ url, fileName, id });
								},
							},
							{
								text: '重新生成',
								showButton(val) {
									let { status } = val;
									return status === 2;
								},
								trigger: row => {
									self.regenerateReport(row);
								},
							},
							{
								text: '刷新',
								showButton(val) {
									let { status } = val;
									return status === 0;
								},
								trigger: () => {
									this.query();
								},
							},
							{
								text: '删除',
								showButton(val) {
									let { type } = val;
									return type === '3';
								},
								trigger: async row => {
									let control = await self.$confirmShow('确认删除？', '提示', {
										confirmButtonText: '确定',
										cancelButtonText: '取消',
									});
									if (control) {
										let { id } = row;
										self.deleteReport(id);
									}
								},
							},
						];
					},
				},
			],
			group: {
				others: [
					{
						tagName: 'sky-select',
						placeholder: '报告类型',
						label: '报告类型',
						value: 1,
						prop: 'type',
						options: [
							{
								value: 1,
								label: '自动周报',
							},
							{
								value: 2,
								label: '自动月报',
							},
							{
								value: 3,
								label: '自定义报告',
							},
						],
					},
					{
						tagName: 'sky-select',
						placeholder: '报告状态',
						label: '报告状态',
						value: '',
						prop: 'status',
						options: [
							{
								value: 1,
								label: '已生成',
							},
							{
								value: 0,
								label: '生成中',
							},
							{
								value: 2,
								label: '生成失败',
							},
						],
					},
					{
						tagName: 'sky-select',
						placeholder: '下载状态',
						label: '下载状态',
						value: '',
						prop: 'downloadStatus',
						options: [
							{
								value: 0,
								label: '全部',
							},
							{
								value: 1,
								label: '已下载',
							},
							{
								value: 2,
								label: '未下载',
							},
						],
					},
					{
						tagName: 'sky-select',
						placeholder: '建议状态',
						label: '建议状态',
						value: '',
						prop: 'remarkStatus',
						options: [
							{
								value: 1,
								label: '已添加',
							},
							{
								value: 2,
								label: '未添加',
							},
						],
					},
					{
						tagName: 'sky-select',
						placeholder: '是否发送报告',
						label: '是否发送报告',
						value: '',
						prop: 'sendStatus',
						options: [
							{
								value: true,
								label: '是',
							},
							{
								value: false,
								label: '否',
							},
						],
					},
					{
						tagName: 'sky-date-picker',
						type: 'week',
						label: '日期',
						startPlaceholder: '开始日期',
						endPlaceholder: '结束日期',
						placeholder: '选择时间',
						prop: 'time',
						datePickerKey: 'week',
						value: getTime(),
						format: 'yyyy 第 WW 周',
						pickerOptions: {
							firstDayOfWeek: 1,
							disabledDate(time) {
								return time.getTime() > Date.now();
							},
						},
					},
					{
						tagName: 'sky-input-prepend',
						placeholder: '输入内容查询',
						label: '',
						prop: ['searchValue', 'searchType'],
						value: ['', 0],
						inputStyle: {
							width: '450px',
						},
						prepend: {
							options: [
								{
									label: '服务单',
									value: 0,
								},
								{
									label: 'CID',
									value: 1,
								},
								{
									label: '优化师',
									value: 2,
								},
							],
							style: {
								width: '180px',
							},
						},
					},
				],
			},
		};
	},
	computed: {
		groupCopy() {
			return JSON.parse(JSON.stringify(this.group));
		},
	},
	watch: {
		'groupCopy.others': {
			handler(val, oldVal) {
				let { value: type } = _.assign(val[0]);
				if (oldVal) {
					let { value: oldType } = _.assign(oldVal[0]);
					if (oldType !== type) {
						if (!type) {
							this.group.others[5].type = 'daterange';
							this.group.others[5].datePickerKey = 'daterange';
							this.group.others[5].format = 'yyyy - MM - dd';
							this.group.others[5].value = [];
							return;
						} else {
							switch (type - 0) {
								case 1:
									this.group.others[5].type = 'week';
									this.group.others[5].datePickerKey = 'week';
									this.group.others[5].format = 'yyyy 第 WW 周';
									this.group.others[5].value = getTime();
									break;
								case 2:
									this.group.others[5].type = 'month';
									this.group.others[5].datePickerKey = 'month';
									this.group.others[5].format = 'yyyy 年 MM 月';
									this.group.others[5].value = getMonthTime();
									break;
								case 3:
									this.group.others[5].type = 'daterange';
									this.group.others[5].datePickerKey = 'daterange';
									this.group.others[5].format = 'yyyy - MM - dd';
									this.group.others[5].value = [];
									break;
							}
						}
					}
				}
			},
			immediate: true,
			deep: true,
		},
	},
	activated() {
		this.query();
	},
	mounted() {
		this.filterChange({
			type: 1,
			timeType: 'week',
			time: getTime(),
		});
	},
	methods: {
		// 删除报告
		async deleteReport(id) {
			try {
				await googleads.deleteReport(id);
				this.$message.success('删除成功');
				this.query();
			} catch (error) {
				this.$message.error('删除失败');
			}
		},
		// 跳转详情
		toReportDetails(id) {
			this.$router.push({
				name: 'reportPreviewSuggestions',
				query: {
					id,
				},
			});
		},
		// 报告下载
		async reportDownload({ url, fileName, id }) {
			await download({ url, fileName });
			await googleads.reportDownloadDetail({ excelPath: url, adReportRecordId: id });
			this.query();
		},
		// 重新生成报告
		async regenerateReport(row) {
			try {
				let { id } = row;
				await googleads.regenerateReport({ id });
				this.query();
			} catch (error) {
				this.$message.error('重新生成失败');
			}
		},
	},
};
</script>
